export default "__VITE_ASSET__ycbXIAsJ__"